var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-slow","mode":"out-in"}},[_c('div',{class:[
      'footer' ]},[_vm._v(" FOOTER ")])])}
var staticRenderFns = []

export { render, staticRenderFns }